import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  ReferenceLine,
  CartesianGrid,
} from "recharts";

function formatXAxisDate(isoString) {
  try {
    const d = new Date(isoString);
    return d.toLocaleDateString(undefined, { month: "short", day: "numeric" });
  } catch {
    return "";
  }
}

function CheckInsSparkline(props) {
  const points = (props.points || []).map((p) => ({
    date: formatXAxisDate(p.conducted_at),
    value: p.value,
  }));

  if (points.length < 2) return null;

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-4">
      <div className="flex items-baseline justify-between mb-2">
        <p className="text-sm font-semibold text-gray-900">{props.label}</p>
        <p className="text-xs text-gray-500">Last {points.length} check-ins</p>
      </div>
      <div style={{ width: "100%", height: 140 }}>
        <ResponsiveContainer>
          <LineChart
            data={points}
            margin={{ top: 8, right: 8, left: -16, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
            <XAxis
              dataKey="date"
              tick={{ fontSize: 11, fill: "#64748b" }}
              tickLine={false}
              axisLine={{ stroke: "#e2e8f0" }}
            />
            <YAxis
              tick={{ fontSize: 11, fill: "#64748b" }}
              tickLine={false}
              axisLine={false}
              width={32}
            />
            <Tooltip
              contentStyle={{
                borderRadius: 8,
                border: "1px solid #e2e8f0",
                fontSize: 12,
              }}
            />
            {props.lowThreshold != null && (
              <ReferenceLine
                y={props.lowThreshold}
                stroke="#f59e0b"
                strokeDasharray="4 4"
                label={{
                  value: `Low: ${props.lowThreshold}`,
                  position: "insideTopRight",
                  fill: "#b45309",
                  fontSize: 10,
                }}
              />
            )}
            <Line
              type="monotone"
              dataKey="value"
              stroke="#6d28d9"
              strokeWidth={2}
              dot={{ r: 3, fill: "#6d28d9" }}
              activeDot={{ r: 5 }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export default CheckInsSparkline;
